<template>
  <div>
    <van-dialog
      class="reward-box--dailog"
      v-model="show"
      :show-confirm-button="false"
      :before-close="handleClose"
      close-on-click-overlay
    >
      <div class="reward-box">
        <div class="title">
          <Avatar class="avatar" :size="26" :src="userInfo.Avatar"></Avatar>
          <span>给作者打赏支持</span>
        </div>
        <div class="money-box">
          <div
            v-for="(item, index) in amountList" :key="index"
            class="option-item text-lighter"
            :class="{active: currIndex === index}"
            @click="choosePrice(index)"
          >￥{{item}}</div>
          <div
            class="option-item text-lighter"
            :class="{active: currIndex === 5}"
            @click="choosePrice(5)"
          >
            <span class="money-icon" v-show="currIndex === 5">￥</span>
            <input type="number" class="priceInput" placeholder="自定义" v-model="customAmount" />
          </div>
          <van-radio-group v-if="!isInWx" v-model="payType" class="pay-type-box">
            <van-radio name="wx" checked-color="#96c05f">微信</van-radio>
            <van-radio name="ali" checked-color="#009ae2">支付宝</van-radio>
          </van-radio-group>
        </div>
        <div class="btn-box">
          <van-button type="primary" size="large" class="pay-btn" @click="payFunc">立即支付</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Avatar from "@/components/avatar";
import { Cms} from "@/api";
import payServices from '@/services/payServices'

export default {
  components: {
    Avatar
  },
  data() {
    return {
      articleId: 0,
      title: "",
      show: false,
      amount: 0,
      customAmount: null,
      currIndex: null,
      userInfo: {
        Avatar: ""
      },
      amountList: [0.1, 0.5, 1, 5, 10],
      // wx 微信， ali 支付宝
      payType: 'wx',
      isInWx: this.$mdUtils.isWeiXin()
    };
  },
  methods: {
    init(data, articleId, title) {
      this.articleId = articleId;
      this.userInfo = data;
      this.title = title;
      this.show = true;
    },
    choosePrice(idx) {
      this.currIndex = idx;
      if (idx < 5) {
        this.amount = this.amountList[parseInt(idx)];
        this.customAmount = null;
      } else {
        this.amount = 0;
      }
    },
    async payFunc() {
      if (this.amount === 0 && this.customAmount <= 0) {
        this.$tips.toast("请正确选择打赏金额");
        return;
      }
      let rewardArticleResp = await this.$api(Cms.RewardArticle, {
        articleId: this.articleId,
        ArticleId: this.articleId,
        amount: this.amount === 0 ? this.customAmount : this.amount,
        Amount: this.amount === 0 ? this.customAmount : this.amount
      });

      payServices.pay({
        paymentId: rewardArticleResp.Id,
        payAmount: rewardArticleResp.Amount,
        payMsg: `打赏-${this.title}`,
        payType:  this.payType,
        payFor: 4,
      }).then(() => {
        this.$mdUtils.isWeiXin() && this.$emit('paySuccess')
        this.handleClose()
      })
    },
   
    handleClose() {
      this.show = false;
      this.priceNum = null;
    }
  }
};
</script>
<style lang='scss' >
.reward-box--dailog {
  width: 90%;
  padding: 20px;
}
.reward-box {
  .title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    text-align: center;

    .avatar {
      margin-right: 10px;
      width: 46px;
      height: 46px;
    }
    span {
      line-height: 46px;
    }
  }

  .money-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 24px;
    padding-bottom: 12px;
    .option-item {
      &.active {
        border: 1px solid red;
      }
      position: relative;
      border: 1px solid $border-color;
      border-radius: 5px;
      text-align: center;
      width: 90px;
      line-height: 50px;
      margin-bottom: 14px;
    }
  }
  .pay-btn {
    width: 100%;
  }
  .money-icon {
    position: absolute;
    top: 0;
    left: 0;
  }
  .priceInput {
    text-align: center;
    width: 88px;
    padding: 0 12px;
    border: none;
    background: none;
  }
  .pay-type-box {
    padding: 10px 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
}
</style>